export default __webpack_public_path__ + "static/Behemoth_Gateway-b65f2a22d4f39f0a800a1ee201b3fe1d.png";